module.exports = __webpack_public_path__ + "static/media/group.0b939de1.svg";